import { render, staticRenderFns } from "./TypePost.vue?vue&type=template&id=31bf91d0&"
import script from "./TypePost.vue?vue&type=script&lang=js&"
export * from "./TypePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports